import { render } from "./PositionsPage.vue?vue&type=template&id=7418f9fc"
import script from "./PositionsPage.vue?vue&type=script&lang=js"
export * from "./PositionsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__